module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-contact",
    attrs: {
      "id": "section-contact"
    }
  }, [_c('div-container', {
    attrs: {
      "full": "true"
    }
  }, [(false) ? _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline"
  }, [_c('div', {
    staticClass: "column is-6 has-text-centered"
  }, [_c('div', {
    staticClass: "cont-desc",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/bosshogcookoff",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/bosshogcookoff",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/bosshogcookoff",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('div', {
    staticClass: "column is-12 has-text-left"
  }, [_c('div', {
    staticClass: "cont-desc",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('h3', {
    staticClass: "title",
    staticStyle: {
      "font-size": "1.8em"
    }
  }, [_vm._v("Contact")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "cont-form cont-form-info",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "value": "",
      "placeholder": "Name"
    },
    on: {
      "input": function($event) {
        return _vm.$v.name.$touch()
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "value": "",
      "placeholder": "Email Address"
    },
    on: {
      "input": function($event) {
        return _vm.$v.email.$touch()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "cont-form cont-form-message",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "maxlength": "500",
      "type": "textarea",
      "placeholder": "Message"
    },
    on: {
      "input": function($event) {
        return _vm.$v.message.$touch()
      }
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "message"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column captcha-image-wrapper"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": _vm.recaptchaKey
    },
    on: {
      "verify": _vm.onVerifyRecaptcha,
      "expired": _vm.onExpiredRecaptcha,
      "render": _vm.onRenderRecaptcha
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.recaptcha),
      expression: "recaptcha",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.recaptcha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.recaptcha = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.recaptcha && _vm.recaptcha.$dirty && _vm.recaptcha.$invalid && _vm.recaptcha.$params.required && !_vm.recaptcha.required) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("Invalid recaptcha.")]) : _vm._e()], 1), _vm._v(" "), (_vm.isDesktop) ? _c('div', {
    staticClass: "column is-4 is-3-mobile"
  }, [_c('button', {
    staticClass: "button is-outlined",
    class: {
      'is-loading': _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.onSend(_vm.$v)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.loading ? ' ' : 'SUBMIT'))])])]) : _vm._e()])]), _vm._v(" "), (!_vm.isDesktop) ? _c('b-field', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('button', {
    staticClass: "button is-outlined",
    class: {
      'is-loading': _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.onSend(_vm.$v)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.loading ? ' ' : 'SUBMIT'))])])]) : _vm._e(), _vm._v(" "), (_vm.feedback) ? _c('p', [_vm._v(_vm._s(_vm.feedback))]) : _vm._e()], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ad51338","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ContactSection.vue
// module id = 905
// module chunks = 1